<aside class="sidebar-sec" [ngClass]="{'collapsed': isCollapsed}">
    <div class="sidelogoss">
        <img *ngIf="!isCollapsed" [src]="bucketurl + '/images/suzuki_logo.png'" style="width:60%;margin-left: 35px;"
            alt="" />
        <img *ngIf="isCollapsed" [src]="bucketurl + '/images/suzuki_s.png'" style="width:30%;margin-left: 10px;"
            alt="" />
        <img style="width:20px;margin-right: 10px;cursor: pointer;" [src]="bucketurl + '/menu/menu_unfold.png'" alt=""
            (click)="toggleSidebar()" />
    </div>
    <hr style="opacity: .25 !important;border-top: 1px #8f8f8f solid;">
    <div class="sidebar-scroll">
        <ul class="sidebar-menu">
            <li class="main-menu has-collapsible">
                <a class="crts" routerLink="/suzuki/overview" routerLinkActive="active" title="Overview" id="overview"
                    #linkRef="routerLinkActive" (click)="setActive('overview')"><span><img
                            [src]="bucketurl + '/menu/' + (linkRef.isActive ? 'overview_selected' : 'overview') + '.png'"
                            alt="" class="menu-img"></span><span class="side-font">Overview</span></a>
            </li>
            <li class="main-menu has-collapsible">
                <a class="crts" routerLink="/suzuki/leads" routerLinkActive="active" title="All Leads" id="leads"
                    #linkRef1="routerLinkActive" (click)="setActive('leads')"><span><img
                            [src]="bucketurl + '/menu/' + (linkRef1.isActive  ? 'all_lead_selected' : 'leads') + '.png'"
                            alt="" class="menu-img"></span><span class="side-font">New Leads</span></a>
            </li>
            <li class="main-menu has-collapsible">
                <a class="crts" routerLink="/suzuki/assigned" routerLinkActive="active" title="Assigned Leads"
                    id="assigned" #linkRef2="routerLinkActive" (click)="setActive('assigned')"><span><img
                            [src]="bucketurl + '/menu/' + (linkRef2.isActive ? 'assigned_selected' : 'assigned') + '.png'"
                            alt="" class="menu-img"></span><span class="side-font">Assigned</span></a>
            </li>
            <li class="main-menu has-collapsible">
                <a class="crts" routerLink="/suzuki/follow-up" routerLinkActive="active" title="Follow Up Leads"
                    id="follow-up" #linkRef3="routerLinkActive" (click)="setActive('follow-up')"><span ><img style="margin-bottom: 13px;"
                            [src]="bucketurl + '/menu/' + (linkRef3.isActive ? 'assigned_selected' : 'follow-up') + '.png'"
                            alt="" class="menu-img"></span><span class="side-font" style="width: 127px;">Follow Up & No Response</span></a>
            </li>
            <!-- <li class="main-menu has-collapsible" id="lost">
                <a class="crts" routerLink="/suzuki/lost" routerLinkActive="active" title="Lost"
                    (click)="setActive('lost')"><span><img 
                        [src]="bucketurl + '/menu/' + (selectedTarget == 'lost' ? 'lost_selected' : 'leads') + '.png'"
                        alt=""
                        class="menu-img">
                   </span><span class="side-font">Lost</span></a>
            </li> -->
            <li class="main-menu has-collapsible">
                <a class="crts" routerLink="/suzuki/junk" id="junk" routerLinkActive="active" title="Junk"
                    #linkRef5="routerLinkActive" (click)="setActive('junk')"><span><img
                            [src]="bucketurl + '/menu/' + (linkRef5.isActive ? 'lost_selected' : 'lost') + '.png'"
                            alt="" class="menu-img"></span><span class="side-font">Junk</span></a>
            </li>
            <li class="main-menu has-collapsible">
                <a class="crts" routerLink="/suzuki/non-sales" id="non-sales" routerLinkActive="active" title="Non Sales"
                    #linkRef8="routerLinkActive" (click)="setActive('non-sales')"><span><img
                            [src]="bucketurl + '/menu/' + (linkRef8.isActive ? 'lost_selected' : 'lost') + '.png'"
                            alt="" class="menu-img"></span><span class="side-font">Non Sales</span></a>
            </li>
            <li class="main-menu has-collapsible">
                <a class="crts" routerLink="/suzuki/create-lead" id="create-lead" routerLinkActive="active"
                    #linkRef4="routerLinkActive" title="Create Lead" (click)="setActive('create-lead')"><span><img
                            [src]="bucketurl + '/menu/' + (linkRef4.isActive ? 'create_lead_selected' : 'create_lead') + '.png'"
                            alt="" class="menu-img"></span><span class="side-font">Create Lead</span></a>
            </li>
            <li class="main-menu has-collapsible">
                <a class="crts" routerLink="/suzuki/users" id="users" routerLinkActive="active"
                    #linkRef6="routerLinkActive" title="Users" (click)="setActive('users')"><span><img
                            [src]="bucketurl + '/menu/' + (linkRef6.isActive ? 'all_lead_selected' : 'leads') + '.png'"
                            alt="" class="menu-img"></span><span class="side-font">User</span></a>
            </li>
            <li class="main-menu has-collapsible guide" style="position: absolute;bottom: 0;width: 90%;">
                <a class="crts" routerLink="/suzuki/user-guide" id="users-guide" routerLinkActive="active"
                    #linkRef7="routerLinkActive" title="User Guide" (click)="setActive('users-guide')"><span><img
                            [src]="bucketurl + '/menu/' + (linkRef7.isActive ? 'lost_selected' : 'lost') + '.png'"
                            alt="" class="menu-img"></span><span class="side-font">User Guide</span></a>
            </li>
        </ul>
    </div>
    <!-- <div class="foot-text">
        <img src="https://lmsinfrabkt.s3.ap-south-1.amazonaws.com/assets/images/dark-logo.png" style="width:70%" alt=""
            class="max_mg" />
    </div> -->
</aside>